import { ServerSidePropsContext } from 'providers/ServerSideProps'
import React, { useContext } from 'react'

const ThemeProvider = ({ children }) => {
  const serverSideContext = useContext(ServerSidePropsContext)
  return (
    <div className={`ThemeProvider ${serverSideContext.siteConfig.theme.className}`}>
      {children}
    </div>
  )
}

export default ThemeProvider